import { useState } from 'react';
import { OptionKey } from '@common-fe/common-fe';

import { useEmployerReactivationStore } from '@/modules/employer/components/EmployerReactivation/stores/useEmployerReactivation.store';

export const useEmployerReactivationAccountUsage = () => {
  const [payrollValue, setPayrollValue] = useState<OptionKey>(undefined);
  const [fundingValue, setFundingValue] = useState<OptionKey>(undefined);
  
  const setStorePayrollValue = useEmployerReactivationStore((state) => state.setPayrollValue);
  const setStoreFundingValue = useEmployerReactivationStore((state) => state.setFundingValue);

  const handlePayrollChange = (value: OptionKey) => {
    setPayrollValue(value);
    setStorePayrollValue(value);
  };

  const handleFundingChange = (value: OptionKey) => {
    setFundingValue(value);
    setStoreFundingValue(value);
  };

  return {
    payrollValue,
    fundingValue,
    handlePayrollChange,
    handleFundingChange,
  };
};
